module.exports = __webpack_public_path__ + "assets/img/home-servicePrice-mf-light.757d4845.png";